import "./src/styles/global.css";
require("@fontsource/overpass");